import React from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';
import EdapModuleView from '../EdapModuleView';
import ReasonsToBelieveItem from './ReasonsToBelieveItem';
import { MODULE_VIEW_EVENT_OPTIONS } from './events';

import {
  Padlock,
  Star,
  House,
  Comments
} from './Icons';

import './ReasonsToBelieve.less';

const ICONS_LOOKUP = {
  'rtb1': Padlock,
  'rtb2': Star,
  'rtb3': House,
  'rtb4': Comments
};

const CNAME = 'RTB';

const ReasonsToBelieve = ({ items, isTouchDevice }) => (
  <section className="Content__section">
    <EdapModuleView eventOptions={MODULE_VIEW_EVENT_OPTIONS}>
      <ul className={cnames(
        `${CNAME}__list row align-with-carousels`,
        { 'align-with-carousels--touch': isTouchDevice }
      )}
      >
        {
          Object.entries(items).map(([key, text]) => {
            const Icon = ICONS_LOOKUP[key];
            return (
              <ReasonsToBelieveItem
                text={text}
                icon={<Icon />}
                key={key}
              />
            );
          })
        }
      </ul>
    </EdapModuleView>
  </section>
);

ReasonsToBelieve.propTypes = {
  items: PropTypes.shape({
    'rtb1': PropTypes.string,
    'rtb2': PropTypes.string,
    'rtb3': PropTypes.string,
    'rtb4': PropTypes.string
  }).isRequired,
  isTouchDevice: PropTypes.bool
};

export default ReasonsToBelieve;